export default class Tab {
  constructor(opt = {}) {
    this.media = opt.media;
  }
  init() {
    this.tab();
  }
  tab(){
    if ( $('.c_nav_tab').length <= 0 ) return;

    $('.c_nav_tab').each(function() {
      if($(this).hasClass('is_current')){
        var tabCurrent = $(this).closest('.c_nav_tab').data('tab-btn');
        $('.c_nav_tab_item').each(function() {
          var tabNum = $(this).data('tab-num');
          if(tabCurrent === tabNum){
           $(this).show();
          }
        });
      }
    });

    $('.c_nav_tab').click(function() {
      $('.c_nav_tab').removeClass('is_current');
      $(this).addClass('is_current');
      var tabBtn = $(this).data('tab-btn');
      $('.c_nav_tab_item').each(function() {
        var tabNum = $(this).data('tab-num');
        if(tabBtn === tabNum){
          $(this).show();
        }else{
          $(this).hide();
        }
      });
      $('.js_carousel_2').slick('setPosition');
    });
  }

}


// WEBPACK FOOTER //
// ./src/assets/js/modules/tab.js